;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('AddCategoryController', AddCategoryController)

  AddCategoryController.$inject = [
    // Angular
    '$uibModalInstance',

    // Managers
    'InvoiceLineManager',

    // Resolve
    'invoice', 'line', 'categories', 'rubrics'

  ]

  function AddCategoryController (
    // Angular
    $uibModalInstance,
    // Managers
    InvoiceLineManager,
    // Resolve
    invoice, line, categories, rubrics
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        categories: categories,
        rubrics: rubrics,

        // Methods
        cancel: cancel,
        getCategories: getCategories,
        saveLine: saveLine
      })

      init()
    }

    function init () {
      if (!line) {
        self.modalTitle = 'Ajouter une catégorie'
      } else {
        self.modalTitle = 'Modifier une catégorie'
        self.title = line.label
      }
      self.invoice = invoice
    }

    function getCategories (search) {
      var newCategories = self.categories.slice()
      if (search && newCategories.indexOf(search) === -1) {
        newCategories.unshift(search)
      }
      return newCategories
    }

    function saveLine () {
      var line = InvoiceLineManager.create({
        label: self.title,
        type: 'label',
        rubric: _.get(self, 'rubric.rubric._id', undefined)
      })
      $uibModalInstance.close(line)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
